import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Initialize i18n with lazy loading
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {},
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false, // Prevent blocking render
    },
  });

// Load translations dynamically
const loadResources = async () => {
  try {
    // Always load French (default/fallback)
    const fr = await import('./locales/fr.json');
    i18n.addResourceBundle('fr', 'translation', fr.default, true, true);
    
    // Load English if that's the detected language
    if (i18n.language === 'en' || i18n.language?.startsWith('en')) {
      const en = await import('./locales/en.json');
      i18n.addResourceBundle('en', 'translation', en.default, true, true);
    }
  } catch (error) {
    console.error('Failed to load translations:', error);
  }
};

// Start loading resources immediately
loadResources();

// Also handle language changes
i18n.on('languageChanged', async (lng) => {
  if (lng === 'en' || lng?.startsWith('en')) {
    if (!i18n.hasResourceBundle('en', 'translation')) {
      try {
        const en = await import('./locales/en.json');
        i18n.addResourceBundle('en', 'translation', en.default, true, true);
      } catch (error) {
        console.error('Failed to load English translations:', error);
      }
    }
  }
});

export default i18n;
